module.exports = __webpack_public_path__ + "img/modelo_small.14217ece.png";